const SERVERCONFIG = {
  url: 'https://api.m2format.de/',
  withCredentials: true
}

export default SERVERCONFIG

